import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {SettingTenantContext} from "../../context/SettingTenantContext"
import SelectSearch from "./SelectSearch"

const TenantFilter = props => {
    const {filters, onChangeFilter} = props
    const SettingTenantPageContext = useContext(SettingTenantContext)

    const {listTenant, listParam} = SettingTenantPageContext

    return (
        <div className="CallHistoryFilters Filters mb-3">
            <div className="itemFilter mb-3">
                <SelectSearch
                    listSelect={listTenant}
                    name='tenantId'
                    value={filters.tenantId}
                    label="Tenant"
                    onChange={onChangeFilter}
                />
            </div>
            <div className="itemFilter mb-3">
                <SelectSearch
                    listSelect={listParam}
                    name='paramName'
                    value={filters.paramName}
                    label="Tham số"
                    onChange={onChangeFilter}
                />
            </div>
        </div>
    )
}

TenantFilter.propTypes = {
    filters: PropTypes.object,
    onChangeFilter: PropTypes.func
}

export default TenantFilter